export const useRuntimeConfig = () => 
window?.__NUXT__?.["nuxt-app"]?.config || window?.useNuxtApp?.("nuxt-app").payload?.config